<template>
  <div class="page-wrapper" style="padding-top: -10px">
    <div v-for="(item,index) in facilitiesData" :key="'keyA'+index" class="mb32">
    <h3 class="mb8">{{item.title}}</h3>
      <div class="item" v-for="item1 in item.list">{{item1.facilitiesName}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AreaInfo",
    props: {
      facilitiesData: {
        type: Array,
        default: null
      }
    },
    watch: {

    },
    data() {
      return {
      }

    },
    computed: {

    },
    methods: {
      showImg(src) {
        this.$emit('showimg', src)
      }
    },
    created() {
    }
  }
</script>

<style scoped>
  .item{
    display: inline-block;
    width: 10%;
  }

</style>
